import React from 'react';
import styled from 'styled-components';
import { useModalStore } from '../../shared/store/portal/modalStore';
import { ModalType } from '../../shared/enum/EnumRepository';
import { getModalMessage } from '../../shared/constants/modalMessages';

const SearchForgot: React.FC = () => {
  const { setStandardModal } = useModalStore();

  const openFindPWModal = () => {
    setStandardModal({
      modalType: ModalType.FIND_PW,
      title: "Password",
      value: null,
      handleChange: () => { },
    });
  };

  return (
    <FindText onClick={openFindPWModal}>{getModalMessage('FORGOT_PASSWORD')}</FindText>
  );
};

const FindText = styled.span`
  font-style: italic;
  text-decoration: underline;
  transition: all 0.3s ease-in-out;
  color: ${({ theme }) => theme.colors.color_Gray_05};
  &:hover {
    transform: scale(1.05);
    color: ${({ theme }) => theme.colors.color_Gray_03};
  }
  ${({ theme }) => theme.typography.Body_04};
  cursor: pointer;
`;


export default SearchForgot;
